// @flow

import { TweenMax, Power2 } from 'gsap';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { SUBSTEP_UPDATE } from '../../../store/actions';
import type { RootState } from '../../../store/types';

export const useDepositAction = () => {
  const dispatch = useDispatch();
  const deposit = useSelector((state: RootState) => state.deposit);
  const history = useHistory();

  // Websocket errors
  useEffect(() => {
    if (deposit.startDeposit.response) {
      const { response } = deposit.startDeposit;

      if (response.external_step) {
        const { action, content } = response.external_step;
        let newSubStep = null;
        if (action === 'redirect') {
          window.location.href = content;
        } else if (action === 'iframe') {
          newSubStep = 2;
        } else if (action === 'html') {
          newSubStep = 3;
        }

        if (newSubStep) {
          dispatch({
            type: SUBSTEP_UPDATE,
            payload: newSubStep,
          });
          TweenMax.to(window, 0.3, {
            scrollTo: { y: 'header', autoKill: true },
            ease: Power2.easeInOut,
          });
        }
      } else if (response.deposit_id) {
        history.push(`/check-deposit/${response.deposit_id}`);
      }
    }
  }, [deposit.startDeposit, dispatch, history]);

  return [];
};
